import { getBookingDetailsByIdUrl } from "../../constants/apiUrls";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export async function deleteBooking(bookingId) {
  return fetch(`${baseUrl}${getBookingDetailsByIdUrl}/${bookingId}`, {
    method: "DELETE",
  });
}
